import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";

/**
 * Polls the server for the current app version to enable reload-on-deploy prompts.
 *
 * @param pollIntervalMs - Polling interval in ms (default: 15 minutes)
 */
export function useAppVersion(pollIntervalMs = 15 * 60_000) {
  const apiFetcher = useApiFetcher();
  return useQuery<string | null>({
    queryKey: QUERY_KEYS.APP_VERSION,
    queryFn: async () => {
      try {
        const data = await apiFetcher<{
          version?: string | null;
        }>("/api/v1/settings/version");
        return data?.version ?? null;
      } catch {
        return null;
      }
    },
    refetchInterval: pollIntervalMs,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    staleTime: 0
  });
}